import React, { MouseEvent, ReactElement } from 'react';
import classNames from 'classnames';
import makeBlockFields from './utils/makeBlockFields';
import CardBlock from 'components/blocks/CardBlock';
import { FieldInterface } from 'components/interfaces/GeneralInterface';
import { isSystemDowngraded } from 'utils/helpers/helpers';
import { CardIconType } from 'components/card/CardIcon';
import styles from './BasicDetailsBlock.module.scss';

interface Props {
    fieldsWithLocalization: FieldInterface[];
    isLight?: boolean;
    isTransparent?: boolean;
    isBlue?: boolean;
    isRed?: boolean;
    isDarkRed?: boolean;
    isWhiteAction?: boolean;
    smallMarginTop?: boolean;
    title?: string;
    className?: string;
    filterOutUnset?: boolean;
    classNameInner?: string;
    onClick?: (e: MouseEvent<HTMLElement>) => void;
    actionInUnsetCardText?: string;
    contextMenu?: {
        label: string;
        action: () => void;
    }[];
    children?: React.ReactChild;
    emptyTitle?: boolean;
    noPadding?: boolean;
    isArchived?: boolean;
    action?: CardIconType;
    isGrey?: boolean;
    childrenFirst?: boolean;
}

const BasicDetailsBlock = ({
    fieldsWithLocalization,
    isLight = false,
    isTransparent = false,
    isBlue = false,
    isRed = false,
    isDarkRed = false,
    isGrey = false,
    title,
    className,
    classNameInner,
    onClick,
    contextMenu,
    isWhiteAction,
    smallMarginTop,
    actionInUnsetCardText,
    filterOutUnset,
    children,
    emptyTitle,
    noPadding,
    isArchived,
    action,
    childrenFirst,
}: Props): ReactElement => (
    <CardBlock
        className={classNames(className, styles.root, {
            [styles.downgraded]: isSystemDowngraded(),
            [styles.smallMarginTop]: smallMarginTop,
        })}
        emptyTitle={emptyTitle}
        noPadding={noPadding}
        lightBcg={isLight}
        transparentBcg={isTransparent}
        blueBcg={isBlue}
        redBcg={isRed}
        redDarkBcg={isDarkRed}
        greyBcg={isGrey}
        archivedBcg={isArchived}
        darkBcg={!isLight && !isTransparent && !isBlue && !isArchived}
        action={
            action
                ? action
                : onClick
                ? {
                      type: 'edit',
                      onClick,
                      isWhite: isWhiteAction,
                  }
                : contextMenu
                ? {
                      type: 'more',
                      isWhite: isWhiteAction,
                      contextMenuActions: contextMenu.map((item) => ({
                          label: item.label,
                          action: item.action,
                      })),
                  }
                : undefined
        }
        title={title}
        actionInUnsetCardText={actionInUnsetCardText}
    >
        <div className={styles.box}>
            {childrenFirst && children}
            {makeBlockFields({
                fields: fieldsWithLocalization,
                filterOutUnset,
                classNameInner,
            })}
            {!childrenFirst && children}
        </div>
    </CardBlock>
);

export default BasicDetailsBlock;
